import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { nonAuthGuard } from './guards/non-auth.guard';
import { permissionGuard } from './guards/permission-guard.service';
import { LoginComponent } from './pages/auth/login/page.component';
import { ForgotComponent } from './pages/auth/forgot/page.component';
import { NavComponent } from './pages/nav/nav.component';
import { HomePage } from './pages/home/home.page';
import { WebhooksPage } from './pages/webhooks/listing.page';
import { WebhookDetailPage } from './pages/webhooks/detail/detail.page';
import { WebhookEditPage } from './pages/webhooks/edit/edit.page';
import { WebhookCreatePage } from './pages/webhooks/create/create.page';
import { PhonesPage} from './pages/phones/listing.page';
import { PhoneDetailPage } from './pages/phones/detail/detail.page';
import { PhoneEditPage } from './pages/phones/edit/edit.page';
import { PhoneCreatePage } from './pages/phones/create/create.page';
import { UsersPage } from './pages/users/listing.page';
import { UserDetailPage } from './pages/users/detail/detail.page';
import { UserEditPage } from './pages/users/edit/edit.page';
import { UserCreatePage } from './pages/users/create/create.page';
import { SequencesPage } from './pages/sequences/listing.page';
import { SequenceDetailPage } from './pages/sequences/detail/detail.page';
import { SequenceEditPage } from './pages/sequences/edit/edit.page';
import { SequenceCreatePage } from './pages/sequences/create/create.page';
import { SequenceEventsPage } from './pages/sequence-events/listing.page';
import { SequenceEventDetailPage } from './pages/sequence-events/detail/detail.page';
import { SequenceEventEditPage } from './pages/sequence-events/edit/edit.page';
import { SequenceEventCreatePage } from './pages/sequence-events/create/create.page';
import { TamperEventsPage } from './pages/tamper-events/listing.page';
import { TamperEventDetailPage } from './pages/tamper-events/detail/detail.page';
import { TamperEventEditPage } from './pages/tamper-events/edit/edit.page';
import { TamperEventCreatePage } from './pages/tamper-events/create/create.page';
import { PeakEventsPage } from './pages/peak-events/listing.page';
import { PeakEventDetailPage } from './pages/peak-events/detail/detail.page';
import { PeakEventEditPage } from './pages/peak-events/edit/edit.page';
import { PeakEventCreatePage } from './pages/peak-events/create/create.page';
import { RawSequenceItemsPage } from './pages/raw-sequence-items/listing.page';
import { RawSequenceItemDetailPage } from './pages/raw-sequence-items/detail/detail.page';
import { RawSequenceItemEditPage } from './pages/raw-sequence-items/edit/edit.page';
import { RawSequenceItemCreatePage } from './pages/raw-sequence-items/create/create.page';
import { ProcessedSequenceItemsPage } from './pages/processed-sequence-items/listing.page';
import { ProcessedSequenceItemDetailPage } from './pages/processed-sequence-items/detail/detail.page';
import { ProcessedSequenceItemEditPage } from './pages/processed-sequence-items/edit/edit.page';
import { ProcessedSequenceItemCreatePage } from './pages/processed-sequence-items/create/create.page';
import { EventsPage } from './pages/events/listing.page';
import { EventDetailPage } from './pages/events/detail/detail.page';
import { EventEditPage } from './pages/events/edit/edit.page';
import { EventCreatePage } from './pages/events/create/create.page';
import { FirmwarePage } from './pages/firmware/listing.page';
import { FirmwareDetailPage } from './pages/firmware/detail/detail.page';
import { FirmwareEditPage } from './pages/firmware/edit/edit.page';
import { FirmwareCreatePage } from './pages/firmware/create/create.page';
import { DeviceStatusesPage } from './pages/device-statuses/listing.page';
import { DeviceStatusDetailPage } from './pages/device-statuses/detail/detail.page';
import { DeviceStatusEditPage } from './pages/device-statuses/edit/edit.page';
import { DeviceStatusCreatePage } from './pages/device-statuses/create/create.page';
import { SensorTypesPage } from './pages/sensor-types/listing.page';
import { SensorTypeDetailPage } from './pages/sensor-types/detail/detail.page';
import { SensorTypeEditPage } from './pages/sensor-types/edit/edit.page';
import { SensorTypeCreatePage } from './pages/sensor-types/create/create.page';
import { ProvidersPage } from './pages/providers/listing.page';
import { ProviderDetailPage } from './pages/providers/detail/detail.page';
import { ProviderEditPage } from './pages/providers/edit/edit.page';
import { ProviderCreatePage } from './pages/providers/create/create.page';
import { DevicesPage } from './pages/devices/listing.page';
import { DeviceDetailPage } from './pages/devices/detail/detail.page';
import { DeviceEditPage } from './pages/devices/edit/edit.page';
import { DeviceCreatePage } from './pages/devices/create/create.page';
import { VersionsPage } from './pages/versions/listing.page';
import { VersionDetailPage } from './pages/versions/detail/detail.page';
import { VersionEditPage } from './pages/versions/edit/edit.page';
import { VersionCreatePage } from './pages/versions/create/create.page';
import { AlgorithmsPage } from './pages/algorithms/listing.page';
import { AlgorithmDetailPage } from './pages/algorithms/detail/detail.page';
import { AlgorithmEditPage } from './pages/algorithms/edit/edit.page';
import { AlgorithmCreatePage } from './pages/algorithms/create/create.page';

import { DocsV1Page } from './pages/docs/v1/page.page';
import { VerifyComponent } from './pages/auth/verify/page.component';

export const routes: Routes = [
    { 
        path: 'login', component: LoginComponent, canActivate: [nonAuthGuard],
    },
    {
        path: 'forgot', component: ForgotComponent, canActivate: [nonAuthGuard],
    },
    {
        path: 'verify', component: VerifyComponent, canActivate: [nonAuthGuard],
    },
    {
        path: '', component: NavComponent, 
        canActivate: [authGuard],
        children: [
            { path: 'dashboard', component: HomePage },
            { path: 'providers', children: [
                { 
                    path: 'create', component: ProviderCreatePage,
                    canActivate: [permissionGuard], 
                    data: { 
                        permission: 'provider_create'
                    } 
                },
                { 
                    path: ':id', component: ProviderDetailPage,
                    canActivate: [permissionGuard], 
                    data: { 
                        permission: 'provider_read'
                    } 
                },
                { 
                    path: ':id/edit', component: ProviderEditPage,
                    canActivate: [permissionGuard], 
                    data: { 
                        permission: 'provider_update'
                    } 
                },
                { 
                    path: '', component: ProvidersPage,
                    canActivate: [permissionGuard], 
                    data: { 
                        permission: 'provider_read'
                    } 
                },
            ] },
            { path: 'webhooks', children: [
                { 
                    path: 'create', component: WebhookCreatePage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'webhook_create'
                    }
                },
                { 
                    path: ':id', component: WebhookDetailPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'webhook_read'
                    }
                },
                { 
                    path: ':id/edit', component: WebhookEditPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'webhook_update'
                    }
                },
                { 
                    path: '', component: WebhooksPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'webhook_read'
                    }
                },
            ] },
            { path: 'phones', children: [
                { 
                    path: 'create', component: PhoneCreatePage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'phone_create'
                    }
                },
                { 
                    path: ':id', component: PhoneDetailPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'phone_read'
                    }
                },
                { 
                    path: ':id/edit', component: PhoneEditPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'phone_update'
                    }
                },
                { 
                    path: '', component: PhonesPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'phone_read'
                    }
                },
            ] },
            { path: 'users', children: [
                { 
                    path: 'create', component: UserCreatePage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'user_create'
                    }
                },
                { 
                    path: ':id', component: UserDetailPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'user_read'
                    }
                },
                { 
                    path: ':id/edit', component: UserEditPage,
                    //canActivate: [permissionGuard],
                    //data: {
                    //    permission: 'user_update'
                    //}
                },
                { 
                    path: '', component: UsersPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'user_read'
                    }
                },
            ] },
            { path: 'devices', children: [
                { 
                    path: 'create', component: DeviceCreatePage,
                    canActivate: [permissionGuard], 
                    data: { 
                        permission: 'device_create'
                    } 
                },
                { 
                    path: ':id', component: DeviceDetailPage,
                    canActivate: [permissionGuard], 
                    data: { 
                        permission: 'device_read'
                    } 
                },
                { 
                    path: ':id/edit', component: DeviceEditPage,
                    canActivate: [permissionGuard], 
                    data: { 
                        permission: 'device_update'
                    } 
                },
                { 
                    path: '', component: DevicesPage,
                    canActivate: [permissionGuard], 
                    data: { 
                        permission: 'device_read'
                    } 
                },
            ] },
            { path: 'sequences', children: [
                { 
                    path: 'create', component: SequenceCreatePage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'sequence_create'
                    }
                },
                { 
                    path: ':id', component: SequenceDetailPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'sequence_read'
                    }
                },
                { 
                    path: ':id/edit', component: SequenceEditPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'sequence_update'
                    }
                },
                { 
                    path: '', component: SequencesPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'sequence_read'
                    }
                },
            ] },
            { path: 'sequence-events', children: [
                { 
                    path: 'create', component: SequenceEventCreatePage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'sequence_event_create'
                    }
                },
                { 
                    path: ':id', component: SequenceEventDetailPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'sequence_event_read'
                    } 
                },
                { 
                    path: ':id/edit', component: SequenceEventEditPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'sequence_event_update'
                    }
                },
                { 
                    path: '', component: SequenceEventsPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'sequence_event_read'
                    }
                },
            ] },
            { path: 'tamper-events', children: [
                { 
                    path: 'create', component: TamperEventCreatePage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'tamper_event_create'
                    }
                },
                { 
                    path: ':id', component: TamperEventDetailPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'tamper_event_read'
                    }
                },
                { 
                    path: ':id/edit', component: TamperEventEditPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'tamper_event_update'
                    }
                },
                { 
                    path: '', component: TamperEventsPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'tamper_event_read'
                    }
                },
            ] },
            { path: 'peak-events', children: [
                { 
                    path: 'create', component: PeakEventCreatePage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'peak_event_create'
                    }
                },
                { 
                    path: ':id', component: PeakEventDetailPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'peak_event_read'
                    }
                },
                { 
                    path: ':id/edit', component: PeakEventEditPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'peak_event_update'
                    }
                },
                { 
                    path: '', component: PeakEventsPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'peak_event_read'
                    }
                },
            ] },
            { path: 'raw-sequence-items', children: [
                { 
                    path: 'create', component: RawSequenceItemCreatePage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'raw_sequence_item_create'
                    } 
                },
                { 
                    path: ':id', component: RawSequenceItemDetailPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'raw_sequence_item_read'
                    } 
                },
                { 
                    path: ':id/edit', component: RawSequenceItemEditPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'raw_sequence_item_update'
                    } 
                },
                { 
                    path: '', component: RawSequenceItemsPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'raw_sequence_item_read'
                    } 
                },
            ] },
            { path: 'processed-sequence-items', children: [
                { 
                    path: 'create', component: ProcessedSequenceItemCreatePage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'processed_sequence_item_create'
                    } 
                },
                { 
                    path: ':id', component: ProcessedSequenceItemDetailPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'processed_sequence_item_read'
                    } 
                },
                { 
                    path: ':id/edit', component: ProcessedSequenceItemEditPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'processed_sequence_item_update'
                    } 
                },
                { 
                    path: '', component: ProcessedSequenceItemsPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'processed_sequence_item_read'
                    } 
                },
            ] },
            { path: 'events', children: [
                { 
                    path: 'create', component: EventCreatePage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'event_create'
                    }
                },
                { 
                    path: ':id', component: EventDetailPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'event_read'
                    }
                },
                { 
                    path: ':id/edit', component: EventEditPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'event_update'
                    }
                },
                { 
                    path: '', component: EventsPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'event_read'
                    }
                },
            ] },
            { path: 'versions', children: [
                { 
                    path: 'create', component: VersionCreatePage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'version_create'
                    }
                },
                { 
                    path: ':id', component: VersionDetailPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'version_read'
                    }
                },
                { 
                    path: ':id/edit', component: VersionEditPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'version_update'
                    }
                },
                { 
                    path: '', component: VersionsPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'version_read'
                    }
                },
            ] },
            { path: 'firmware', children: [
                { 
                    path: 'create', component: FirmwareCreatePage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'firmware_create'
                    }
                },
                { 
                    path: ':id', component: FirmwareDetailPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'firmware_read'
                    }
                },
                { 
                    path: ':id/edit', component: FirmwareEditPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'firmware_update'
                    }
                },
                { 
                    path: '', component: FirmwarePage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'firmware_read'
                    }
                },
            ] },
            { path: 'device-statuses', children: [
                { 
                    path: 'create', component: DeviceStatusCreatePage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'device_status_create'
                    }
                },
                { 
                    path: ':id', component: DeviceStatusDetailPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'device_status_read'
                    }
                },
                { 
                    path: ':id/edit', component: DeviceStatusEditPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'device_status_update'
                    }
                },
                { 
                    path: '', component: DeviceStatusesPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'device_status_read'
                    }
                },
            ] },
            { path: 'sensor-types', children: [
                { 
                    path: 'create', component: SensorTypeCreatePage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'sensor_type_create'
                    }
                },
                { 
                    path: ':id', component: SensorTypeDetailPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'sensor_type_read'
                    }
                },
                { 
                    path: ':id/edit', component: SensorTypeEditPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'sensor_type_update'
                    }
                },
                { 
                    path: '', component: SensorTypesPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'sensor_type_read'
                    }
                },
            ] },
            { path: 'algorithms', children: [
                { 
                    path: 'create', component: AlgorithmCreatePage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'algorithm_create'
                    }
                },
                { 
                    path: ':id', component: AlgorithmDetailPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'algorithm_read'
                    }
                },
                { 
                    path: ':id/edit', component: AlgorithmEditPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'algorithm_update'
                    }
                },
                { 
                    path: '', component: AlgorithmsPage,
                    canActivate: [permissionGuard],
                    data: {
                        permission: 'algorithm_read'
                    }
                },
            ] },
            { path: 'docs', children: [
                { path: 'v1', children: [
                    { 
                        path: '', component: DocsV1Page,
                        canActivate: [permissionGuard],
                        data: {
                            permission: 'developer_docs'
                        }
                    },
                ] },
                { path: '**', redirectTo: 'v1' }
            ] },
            // redirect to home if no route is found
            { path: '**', redirectTo: 'dashboard' }
        ]
    }
];